import { FabricObject, Point } from 'fabric';

// Snapshots the element's bounding-box width/height *before* a
// mutation and returns a callback that re-centers the element after
// the mutation, compensating for any bbox delta (grows / shrinks).
// Used by every text mutation that reflows layout (fontFamily,
// fontSize, italic, bold, underline) so the visual center stays put.
function initCenterElementOnItself(fElement: FabricObject) {
    const coords = fElement.getCoords();
    const oldVec = new Point(coords[1].x - coords[0].x, coords[1].y - coords[0].y);

    return function (fElementUpdated: FabricObject) {
        const newCoords = fElementUpdated.getCoords();
        const newVec = new Point(newCoords[1].x - newCoords[0].x, newCoords[1].y - newCoords[0].y);
        const decal = newVec.subtract(oldVec);
        fElementUpdated.set('left', fElementUpdated.left - decal.x / 2);
        fElementUpdated.set('top', fElementUpdated.top - decal.y / 2);
        fElementUpdated.set('dirty', true);
        fElementUpdated.setCoords();
    };
}

export { initCenterElementOnItself };
